module.exports = __webpack_public_path__ + "img/insurance-logo-17.ba74d942.png";